<div *ngIf="productResponse.id" class="d-flex align-items-center">
  <div class="product-thumb-wrapper me-1">
    <ng-container *ngIf="!productImageError && productResponse.multimedia?.[0]?.url; else productPlaceholder">
      <img class="rounded-circle" [src]="productResponse.multimedia[0].url" height="50" width="50" alt="product-img"
        (error)="onProductImageError()" />
    </ng-container>
    <ng-template #productPlaceholder>
      <div class="avatar avatar-md mx-1 bg-light-secondary">
        <div class="avatar-content d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
          <i class="bi bi-image-alt font-medium-3 text-muted"></i>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="cell-line-height">
    <p class="font-medium-1 line-height-1 mb-0">
      {{productResponse.title}}
    </p>
    <span *ngIf="filterObject.data.length > 1" class="grey font-small-3">
      {{filterObject.data.length}} + Items</span>
  </div>
</div>

<div *ngIf="CategoryResponse.default_label" class="d-flex align-items-center">
  <div class="product-thumb-wrapper me-1">
    <ng-container *ngIf="!categoryImageError && CategoryResponse.icon?.url; else categoryPlaceholder">
      <img class="rounded-circle" [src]="CategoryResponse.icon.url" height="50" width="50" alt="cat"
        (error)="onCategoryImageError()" />
    </ng-container>
    <ng-template #categoryPlaceholder>
      <div class="avatar avatar-md mx-1 bg-light-secondary">
        <div class="avatar-content d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;">
          <i class="bi bi-image-alt font-medium-3 text-muted"></i>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="cell-line-height">
    <p class="font-medium-1 line-height-1 mb-0">
      {{CategoryResponse.default_label}}
    </p>
    <span *ngIf="filterObject.data.length > 1" class="grey font-small-3">
      {{filterObject.data.length}} + Items</span>
  </div>
</div>

<!--div class="d-flex align-items-center">
    <div *ngIf="row.multimedia && row.multimedia.length > 0; else customAvatar">
      <img
        class="rounded-circle mx-1"
        [src]="getImageUrl(row.multimedia)"
        height="50"
        width="50"
        alt="product-img"
      />
    </div>
    <ng-template #customAvatar>
      <div class="avatar avatar-lg mx-1" ngClass="bg-light-secondary">
        <div class="avatar-content"> <i class="bi bi-image-alt font-medium-3"></i></div>
      </div>
    </ng-template>
    <div class="cell-line-height">
      <p class="font-medium-1 line-height-1 mb-0">
        {{ title }}
      </p>
      
    </div>
  </!--div-->